import React from 'react';
import '../components/Navigation.css';

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Loveario</h3>
            <p>Data platform engineering, cloud architecture &amp; BI consultancy.</p>
          </div>
          <div className="footer-section">
            <h3>Contact Info</h3>
            <p>📍 Cambridge, United Kingdom</p>
            <p>📧 <a href="mailto:clintdatagroove@gmail.com">clintdatagroove@gmail.com</a></p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <p><a href="/">Home</a></p>
            <p><a href="/about">About</a></p>
            <p><a href="/contact">Contact</a></p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Loveario. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
